import { ReactNode, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

interface Props {
  children: ReactNode;
}

export default function AdminLayout({ children }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0b0b0c] text-white md:flex">
      {/* MOBILE OVERLAY */}
      <AnimatePresence>
        {open && (
          <motion.div
            onClick={() => setOpen(false)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm md:hidden"
          />
        )}
      </AnimatePresence>

      {/* SIDEBAR */}
      <div
        className={`fixed inset-y-0 left-0 z-50 transition-transform duration-300 md:sticky md:top-0 md:h-screen md:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar onClose={() => setOpen(false)} />
      </div>

      {/* MAIN */}
      <div className="flex min-h-screen w-full flex-col md:min-w-0 md:flex-1">
        <header className="sticky top-0 z-30 flex h-16 items-center border-b border-zinc-800/80 bg-zinc-950/90 px-4 backdrop-blur md:px-6">
          <Topbar onMenu={() => setOpen(true)} />
        </header>

        <main className="mx-auto w-full max-w-[1600px] flex-1 px-4 py-6 md:px-8 md:py-8">
          {children}
        </main>

        <footer className="border-t border-zinc-800/60 px-4 py-4 text-[10px] uppercase tracking-[0.2em] text-zinc-600 md:px-8">
          Casafrique · Monolith assets · Admin operations
        </footer>
      </div>
    </div>
  );
}
